export default __webpack_public_path__ + "img/hourback1-590180cb.png";